function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M600 1871 c-299 -150 -378 -194 -392 -217 -16 -26 -18 -65 -18 -437 0 -431 2 -449 48 -500 22 -25 86 -57 112 -57 20 0 20 4 20 445 l0 445 23 14 c50 31 581 306 592 306 6 0 131 -63 278 -140 l266 -140 115 0 c129 0 135 4 97 66 -16 26 -84 64 -385 218 -201 102 -369 186 -373 185 -4 0 -177 -85 -383 -188z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592 1487 c-42 -16 -91 -63 -108 -104 -11 -26 -14 -127 -14 -490 0 -424 2 -461 19 -498 22 -48 54 -79 103 -100 32 -13 122 -15 676 -15 l638 0 50 25 c28 14 59 40 74 62 l25 37 3 474 c3 468 2 475 -19 519 -13 27 -37 55 -62 71 l-41 27 -655 2 c-488 1 -664 -1 -689 -10z m974 -331 c164 84 302 154 307 154 4 0 7 -34 7 -75 0 -67 -2 -76 -22 -88 -13 -8 -151 -80 -308 -159 l-285 -146 -302 156 -303 155 0 80 0 79 303 -155 303 -155 300 154z"
}));

var SvgUnread = function SvgUnread(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnread, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unread.17c123a7.svg";
export { ForwardRef as ReactComponent };